<template>
  <div class="static">
    <MetaTags v-if="metaInfo" :meta-info="metaInfo" />
    <div class="static__content">
      <component :is="pageContent"></component>
    </div>
  </div>
</template>

<script>
import { staticPage } from '@/app/routes';
import * as actions from '@/app/store/action-types';
import config from '@/config';
import cookies from './cookies.vue';
import useSafeRoute from '@/app/composables/useSafeRoute';
import MetaTags from '@/app/components/MetaTags.vue';
import utils from '@/app/utils/utils';

export default {
  name: 'static',
  setup() {
    const route = useSafeRoute();
    return { route };
  },
  data: () => ({
    title: '',
    texts: []
  }),
  computed: {
    metaInfo() {
      return {
        title: 'OP Koti',
        meta: utils.getMetaTagsForPage(
          'OP Koti',
          'OP Koti',
          ''
        ),
      };
    },
    pageContent() {
      if (this.route.path.includes(staticPage.paths.calculatorTerms)) {
        return calculatorTerms;
      }
      if (this.route.path.includes(staticPage.paths.cookies)) {
        return cookies;
      }

      return opInfo;
    }
  },
  mounted() {
    void this.$store.dispatch(actions.analytics.set, { pageName: 'static', eVar17: this.metaInfo.title });
    void this.$store.dispatch(actions.analytics.track, config.analytics.eventTypes.pageView);
  },
  components: {
    MetaTags,
  },
};
</script>
